import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { isCode } from '@/utils/validate';
import { getPhoneCode } from '@/api/user';
import navLocale from '@/layouts/components/navBar/navLocale.vue';
import { LANGUAGE_RESOURCE } from '@/utils/public';
import { systemConfigResourse } from '@/views/system/settings/request.js';
import loginErrorModal from './loginErrorModal';
import { mapState } from 'vuex';
export default {
  name: 'login',
  components: {
    navLocale,
    loginErrorModal
  },
  data() {
    return {
      currentTab: '2',
      loginForm: {
        username: '',
        account: '',
        password: '',
        phone: '',
        code: '',
        remember: true
      },
      loading: false,
      phoneCode: '获取验证码',
      codeStatus: false,
      currentCode: null,
      localeList: [{
        name: '简体中文',
        key: 'zh_CN'
      }, {
        name: '繁體中文',
        key: 'zh_TW'
      }, {
        name: 'English',
        key: 'en_US'
      }],
      globalRoamingOptionData: [{
        label: '+86',
        value: '中国大陆',
        code: 'CN'
      }, {
        label: '+886',
        value: '中国台湾',
        code: 'TW'
      }, {
        label: '+852',
        value: '中国香港',
        code: 'HK'
      }, {
        label: '+853',
        value: '中国澳门',
        code: 'MO'
      }, {
        label: '+1',
        value: '美国',
        code: 'US'
      }, {
        label: '+65',
        value: '新加坡',
        code: 'SG'
      }],
      cookieConfig: null,
      //cookie问询
      systemConfigResourse: {},
      //底栏文件资源
      cookieBoxVisible: true,
      //cookie问询弹框
      cookieModelVisible: false,
      //个性化设置弹框
      columns: [{
        title: '基础设置',
        dataIndex: 'set'
      }, {
        title: '始终处于活跃状态',
        dataIndex: 'operation',
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      switchOne: false,
      switchTwo: false,
      switchThree: false,
      loginErrorVisible: false,
      contactWay: {},
      cancellationTime: '',
      en: {
        基础设置标题: 'Essential',
        基础设置内容: 'Essential cookies are necessary to provide our site and services and cannot be deactivated. They are usually set in response to your actions on the site, such as setting your privacy preferences, signing in, or filling in forms.',
        性能标题: 'Performance',
        性能内容: 'Performance cookies provide anonymous statistics about how customers navigate our site so we can improve site experience and performance. Approved third parties may perform analytics on our behalf, but they cannot use the data for their own purposes.',
        功能标题: 'Functional',
        功能内容: 'Functional cookies help us provide useful site features, remember your preferences, and display relevant content. Approved third parties may set these cookies to provide certain site features. If you do not allow these cookies, then some or all of these services may not function properly.',
        广告标题: 'Advertising',
        广告内容: 'Advertising cookies may be set through our site by us or our advertising partners and help us deliver relevant marketing content. If you do not allow these cookies, you will experience less relevant advertising.'
      }
    };
  },
  computed: {
    ...mapState({
      locale: state => state.setting.locale
    }),
    loginRules() {
      return {
        username: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePhone
        }],
        account: [{
          required: true,
          trigger: 'blur',
          validator: this.validateUsername
        }, {
          min: 8,
          max: 50,
          message: this.$t('长度在 8 到 50 个字符'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePassword
        }],
        phone: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePhone
        }],
        code: [{
          required: true,
          trigger: 'blur',
          validator: this.validateCode
        }]
      };
    },
    language() {
      return LANGUAGE_RESOURCE[this.$store.state.setting.locale];
    },
    personalSet: {
      get() {
        return JSON.parse(localStorage.getItem('personalSet'));
      },
      set(val) {
        localStorage.setItem('personalSet', JSON.stringify(val));
      }
    }
  },
  watch: {
    // 监听语言变化
    '$store.state.setting.locale': {
      handler: function (val, oldVal) {
        this.getSystemConfig();
      },
      deep: true
    },
    // 监听personalSet，有值给button赋值
    personalSet: {
      handler: function (val, oldVal) {
        console.log(val);
        if (val) {
          this.switchOne = val.switchOne;
          this.switchTwo = val.switchTwo;
          this.switchThree = val.switchThree;
        }
      },
      deep: true
    }
  },
  async created() {
    // 1、获取当前页面的域名，并存储在 hostname 变量中
    const hostname = process.env.VUE_APP_BASE_API;
    //2、 然后，代码检查 hostname 是否包含特定的国内和海外域名。
    if (hostname.includes('console.insureforce.cn')) {
      // 3、如果是国内域名（console.insureforce.cn），则将手机号区号设置为 '+86'，并将其存储在 sessionStorage 中。
      // 国内域名，默认手机区号为 +86
      this.$set(this.loginForm, 'globalRoaming', '+86');
      sessionStorage.setItem('globalRoaming', '+86');
    } else if (hostname.includes('console.sg.insurforce.ai')) {
      //4、 如果是海外域名（console.sg.insurforce.ai），则将手机号区号设置为 '+1'，并将其存储在 sessionStorage 中。
      // 海外域名，默认手机区号为 +1
      this.$set(this.loginForm, 'globalRoaming', '+1');
      sessionStorage.setItem('globalRoaming', '+1');
    } else {
      this.$set(this.loginForm, 'globalRoaming', '+86');
      sessionStorage.setItem('globalRoaming', '+86');
    }

    //5、 接下来，代码检查 sessionStorage 中是否存在键为 'changeLocale' 的项。
    // 如果不存在，根据当前域名确定当前语言环境（'zh_CN' 或 'en_US'），并将其保存到 sessionStorage 和 Vuex store 中。
    if (!sessionStorage.getItem('changeLocale')) {
      const locale = hostname.includes('console.insureforce.cn') ? 'zh_CN' : 'en_US';
      this.$store.commit('setting/CHANGE_LOCALE', locale);
      sessionStorage.setItem('locale', locale);
    }

    // 底栏资源
    this.getSystemConfig();
    // cookie问询
    if (this.personalSet !== null && this.personalSet !== undefined) {
      this.cookieBoxVisible = false;
    }
    // 判断personalSet，有值给button赋值
    if (this.personalSet) {
      this.switchOne = this.personalSet.switchOne;
      this.switchTwo = this.personalSet.switchTwo;
      this.switchThree = this.personalSet.switchThree;
    }
  },
  methods: {
    changeGlobalRoaming(value) {
      this.$set(this.loginForm, 'phone', '');
    },
    validateUsername(rule, value, callback) {
      let reg = /^[\w@.\-_]+$/;
      if (value.trim().length === 0) {
        callback(new Error(this.$t('用户名不能为空')));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('仅限输入大小写字母、数字或特殊字符“@”和“.”“-”“_”')));
      } else {
        callback();
      }
    },
    validatePassword(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('密码必填')));
      } else {
        callback();
      }
    },
    validatePhone(rule, value, callback) {
      const regMap = {
        CN: /^1[3456789]\d{9}$/,
        // 中国
        TW: /^09\d{8}$/,
        // 台湾
        HK: /^([6|9])\d{7}$/,
        // 香港
        MO: /^[6]\d{7}$/,
        // 澳门
        US: /^[1-9]\d{9}$/,
        // 美国
        SG: /^[89]\d{7}$/ // 新加坡
      };
      let findItem = this.globalRoamingOptionData.find(item => item.label === this.loginForm.globalRoaming);
      if (findItem && findItem.length === 0) {
        callback();
      }
      let regValue = regMap[findItem.code];
      if (!regValue.test(value)) {
        callback(new Error(this.$t('手机号码有误，请重新填写')));
      } else {
        callback();
      }
    },
    validateCode(rule, value, callback) {
      if (!isCode(value)) {
        callback(new Error(this.$t('验证码有误，请重新填写')));
      } else {
        callback();
      }
    },
    focusPassword() {
      this.$refs.password.focus();
    },
    //获取验证码
    getCode() {
      let mobile = this.currentTab == '1' ? this.loginForm.globalRoaming + this.loginForm.phone : this.loginForm.phone;
      getPhoneCode({
        mobile: mobile,
        way: 'login'
      }).then(res => {
        this.codeStatus = true;
        let time = 60;
        var getPhoneIntval = setInterval(() => {
          if (time > 0) {
            time--;
            this.phoneCode = this.$t('重新获取') + `(${time}s)`;
          } else {
            clearInterval(getPhoneIntval);
            getPhoneIntval = null;
            this.phoneCode = this.$t('获取验证码');
            this.codeStatus = false;
          }
        }, 1000);
        this.$refs.code.focus();
      });
    },
    //登录
    toLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const {
            phone,
            password,
            code,
            account,
            globalRoaming
          } = this.loginForm;
          let params = {
            way: Number(this.currentTab)
          };
          if (this.currentTab === '2') {
            params.account = account;
            params.password = password;
          } else {
            params.mobile = phone;
            params.code = code;
            params.globalRoaming = globalRoaming;
          }
          this.$store.dispatch('user/login', params).then(res2 => {
            if (res2.code != 200) {
              return this.$message.error(this.$t(res2.message));
            }
            const res = res2.data;
            this.loading = false;
            // 判断账号是否注销-用户状态：true 注销 false 正常
            if (res.logOffStatus) {
              // 单账号
              this.loginErrorVisible = true;
              this.cancellationTime = res.cancellationTime;
              sessionStorage.setItem('contactWay', JSON.stringify(this.contactWay));
              return;
            }
            if (!res.multipleAccounts) {
              this.$router.push({
                path: '/index'
              });
              clearInterval();
              this.$store.dispatch('user/setUploadTrackback');
            } else {
              sessionStorage.setItem('loginInfo', JSON.stringify(params));
              sessionStorage.setItem('multipleAccounts', JSON.stringify(res.accountInfo));
              // 存储联系方式
              sessionStorage.setItem('contactWay', JSON.stringify(this.contactWay));
              this.$router.push({
                path: '/account'
              });
            }
            this.$store.commit('message/CLEAR_POP_MESSAGE_LIST');
            this.$store.dispatch('message/loopPopMessageList', {});
            // this.$store.dispatch('message/getSystemForcePopMessageList', {});
            this.$store.dispatch('message/getUnReadCount');
          }).catch(() => {
            setTimeout(() => {
              this.loading = false;
            }, 500);
          });
        } else {
          return false;
        }
      });
    },
    // 底栏文件资源
    async getSystemConfig() {
      let res = await systemConfigResourse({
        type: '0'
      });
      this.systemConfigResourse = res;
      // cookie问询弹框
      const cookieConfigs = this.systemConfigResourse[5];
      this.cookieConfig = cookieConfigs[this.language];
      // 联系方式
      const contactWay = this.systemConfigResourse[1];
      if (!contactWay[this.language]) {
        if (process.env.VUE_APP_BASE_API.includes('console.insureforce.cn')) {
          // 国内-中文
          this.contactWay = contactWay['zh'];
        } else {
          // 海外-英文
          this.contactWay = contactWay['en'];
        }
      } else {
        this.contactWay = contactWay[this.language];
      }
    },
    jumpArticlePage(type) {
      if (type === '3') {
        // 使用协议
        const agreementObj = this.systemConfigResourse[type];
        if (!agreementObj[this.language]) {
          // 海外地址默认英文，国内地址默认中文
          if (process.env.VUE_APP_BASE_API.includes('console.insureforce.cn')) {
            // 国内-中文
            let routeData = this.$router.resolve({
              path: `/system/settings/previewPage/${agreementObj.zh.id}/zh/${type}`
            });
            window.open(routeData.href, '_blank');
          } else {
            // 海外-英文
            let routeData = this.$router.resolve({
              path: `/system/settings/previewPage/${agreementObj.en.id}/en/${type}`
            });
            window.open(routeData.href, '_blank');
          }
        } else {
          let routeData = this.$router.resolve({
            path: `/system/settings/previewPage/${agreementObj[this.language].id}/${this.language}/${type}`
          });
          window.open(routeData.href, '_blank');
        }
      } else if (type === '4') {
        // 隐私政策
        const privacyObj = this.systemConfigResourse[type];
        if (!privacyObj[this.language]) {
          // 海外地址默认英文，国内地址默认中文
          if (process.env.VUE_APP_BASE_API.includes('console.insureforce.cn')) {
            // 国内-中文
            let routeData = this.$router.resolve({
              path: `/system/settings/previewPage/${privacyObj.zh.id}/zh/${type}`
            });
            window.open(routeData.href, '_blank');
          } else {
            // 海外-英文
            let routeData = this.$router.resolve({
              path: `/system/settings/previewPage/${privacyObj.en.id}/en/${type}`
            });
            window.open(routeData.href, '_blank');
          }
        } else {
          let routeData = this.$router.resolve({
            path: `/system/settings/previewPage/${privacyObj[this.language].id}/${this.language}/${type}`
          });
          window.open(routeData.href, '_blank');
        }
      }
    },
    cookieManageCli() {
      const cookieConfigs = this.systemConfigResourse['5'];
      // 判断是否存在该语言
      if (!this.cookieConfig) {
        if (process.env.VUE_APP_BASE_API.includes('console.insureforce.cn')) {
          // 国内-中文
          this.cookieConfig = cookieConfigs['zh'];
        } else {
          // 海外-英文
          this.cookieConfig = cookieConfigs['en'];
        }
      } else {
        this.cookieConfig = cookieConfigs[this.language];
      }
      this.cookieModelVisible = true;
    },
    // 个性化设置
    personalSetCli() {
      this.cookieBoxVisible = false;
      this.cookieModelVisible = true;
    },
    // 全部允许
    allowHandle() {
      // 全部开关开开
      this.switchOne = true;
      this.switchTwo = true;
      this.switchThree = true;
      // 存储个性化
      let personalSet = {
        switchOne: true,
        switchTwo: true,
        switchThree: true
      };
      localStorage.setItem('personalSet', JSON.stringify(personalSet));
      // cookie问询弹框
      this.cookieBoxVisible = false;
      this.cookieModelVisible = false;
    },
    switchChange(key, val) {
      this[key] = val;
    },
    // 保存我得设置
    savePersonalSet() {
      let personalSet = {
        switchOne: this.switchOne,
        switchTwo: this.switchTwo,
        switchThree: this.switchThree
      };
      localStorage.setItem('personalSet', JSON.stringify(personalSet));
      this.cookieModelVisible = false;
    }
  }
};